import { useDispatch } from 'react-redux';

import { subscriptionActions } from '../../../../store/modules/subscription';

const useResetAfterSuccessUpgrade = () => {
  const dispatch = useDispatch();

  return () => {
    dispatch(subscriptionActions.resetUpdateCardState());
    dispatch(subscriptionActions.resetSubscriptionChangeState());
  };
};

export default useResetAfterSuccessUpgrade;
